module.exports = __webpack_public_path__ + "static/info2-1c7d823eeae43912960cc90983299857.png";